import React, { ReactNode } from 'react';
import { TypographyH3 } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

interface TestCardGroupProps {
    groupName: string;
    children: ReactNode;
    className?: string;
}

function TestCardGroup({ groupName, children, className }: TestCardGroupProps): React.JSX.Element {
    return (
        <div
            className={cn(
                'border-border bg-alicia gap-x-3 rounded-lg border p-4',
                'row-span-4 row-start-1 grid auto-cols-auto grid-rows-subgrid',
                '[&>.test-card:only-of-type]:col-span-2',
                className,
            )}
        >
            <TypographyH3 className="text-foreground col-span-2 row-start-1 mb-3 text-center">{groupName}</TypographyH3>
            {children}
        </div>
    );
}

export default TestCardGroup;
